import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/plugins/i18n";
import apolloProvider from "@/plugins/gql";

import "@/plugins/elementUI";
import "@/plugins/clipboard";
import "@/assets/css/all.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";

Vue.config.productionTip = false;

new Vue({
  store,
  i18n,
  router,
  apolloProvider,
  render: h => h(App)
}).$mount("#app");
